import {
  type ReactNode,
  createContext,
  useCallback,
  useContext,
  useState
} from 'react'

import { AddCompanySheet } from '@/domains/companies'

const OpenAddCompanySheetContext = createContext<() => void>(() => undefined)

/* above the sidebar, since the phone drawer unmounts its contents on close. */
export function AddCompanySheetProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false)
  const openSheet = useCallback(() => setOpen(true), [])
  return (
    <OpenAddCompanySheetContext.Provider value={openSheet}>
      {children}
      <AddCompanySheet open={open} onOpenChange={setOpen} />
    </OpenAddCompanySheetContext.Provider>
  )
}

export function useOpenAddCompanySheet(): () => void {
  return useContext(OpenAddCompanySheetContext)
}
